<!-- @format -->

<invoice-detail-tag>
    <div class="container_breadcrumb">
        <ul class="breadcrumb">
            <li class="breadcrumb-item"><span class="heading-01 heading_orders">受注履歴・請求関連</span></li>
            <li class="breadcrumb-item"><a
                    href="/project/history">受注履歴と確定報酬一覧</a>
            </li>
            <li class="breadcrumb-item">プロジェクト請求書</li>
        </ul>
    </div><!--/.container_breadcrumb-->

    <a name="detail"></a>

    <div class="contents" if={(loaded === true)}>

        <h2 class="pay_heading margin-spacing-1_bottom" style="color: #0a1415;">お客様名：{invoice.client_name}様</h2>

        <section class="contents_area">
            <div class="container_pay margin-spacing-4_bottom">
                <div class="pay_info">
                    <ul class="information_list">
                        <li class="information_list-item "><span
                                class="information_list-item-title">プロジェクトID:</span>{invoice.project_id}
                        </li>
                        <li class="information_list-item " if={invoice.created_at}><span
                                class="information_list-item-title">発行日:</span>
                            {invoice.created_at}
                        </li>
                        <li class="information_list-item " if={invoice.paid_at}><span
                                class="information_list-item-title">お支払い日:</span>
                            {invoice.paid_at}
                        </li>

                    </ul><!--/.information_list-->
                    <div class="button button-secondary-mini button-download"
                         onclick="{ e => pdf(e,invoice.project_id) }">この請求書のPDF
                    </div>
                </div><!--/.pay_info-->

                <div class="wrap_pay">
                    <p class="pay_heading">ご請求金額</p>
                    <p class="pay"><span class="pay-amount"><number-format number={invoice.amount_project}/></span>円(税込)
                    </p>
                </div><!--/.wrap_pay-->

            </div><!--/.container_pay-->

            <div class="contents_block table">

                <h2 class="heading-03 margin-spacing-2_bottom">収納代⾏（編集者・ライターへの報酬金）による請求額</h2>

                <div style="display: flex;justify-content: right">
                    <table class="documents_table bre margin-spacing-2_bottom">
                        <caption style="font-size:1.5rem;font-weight:bold">対象プロジェクト</caption>
                        <thead>
                        <tr>
                            <th>プロジェクトID</th>
                            <th>受託者</th>
                            <th style="text-align:right">プロジェクト発注金額(税抜)</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>{invoice.project_id}</td>
                            <td>{invoice.worker_real_name}</td>
                            <td class="price">
                                <number-format number={invoice.sub_amount_project}/>
                                円
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>


                <div style="display: flex;justify-content: right">
                    <table class="documents_table bre margin-spacing-2_bottom" style="width:40%">
                        <tbody>
                        <tr>
                            <th class="price">税率
                                <tax-rate tax_rate={invoice.tax_rate}
                                          invoice_provider_state_worker={invoice.invoice_provider_state_worker}/>
                                対象額　小計（税抜）
                            </th>
                            <td class="price" style="font-weight:normal;font-size:1.25rem">
                                <number-format number={invoice.sub_amount_project}/>
                                円
                            </td>
                        </tr>

                        <tr if={invoice.company_type === 2}>
                            <th class="price">源泉徴収税額</th>
                            <td class="price" style="font-weight:normal;font-size:1.25rem">▲
                                <number-format number={invoice.tax_withholding}/>
                                円
                            </td>
                        </tr>

                        <tr>
                            <th class="price">消費税額（税率
                                <tax-rate tax_rate={invoice.tax_rate}
                                          invoice_provider_state_worker={invoice.invoice_provider_state_worker}/>
                                ）
                            </th>
                            <td class="price" style="font-weight:normal;font-size:1.25rem">
                                <tax-price tax_price={invoice.tax_project}
                                           invoice_provider_state_worker={invoice.invoice_provider_state_worker}
                                           unit_char="円"/>
                            </td>
                        </tr>

                        <tr>
                            <th class="price">
                                <span if={invoice.company_type === 2}>差引請求額(税込)</span>
                                <span if={invoice.company_type === 1}>請求額(税込)</span>
                            </th>
                            <td class="price">
                                <number-format number={invoice.amount_project}/>
                                円
                            </td>
                        </tr>

                        </tbody>
                    </table>
                </div>


                <!--
                <ul>
                  <li style="font-size:1.5rem;padding:0.5rem 0;font-weight:bold">
                    税率10%対象額　小計（税抜）：<number-format number="3500">3,500</number-format>円
                  </li>
                  <li style="font-size:1.5rem;padding:0.5rem 0">
                    消費税額（税率10%）：100円
                  </li>
                  <li style="font-size:1.5rem;padding:0.5rem 0"><hr></li>
                  <li style="font-size:1.5rem;padding:0.5rem 0">
                  <strong>
                    合計(税込)：
                    <span style="margin-bottom: 2rem">
                      <number-format number="1600">1,600</number-format>円
                    </span>
                  </strong>
                </li>
                </ul>
        -->

                <!--
                          <table class="contents_table pay-detail_table margin-spacing-3_top margin-spacing-3_bottom">
                            <tbody>
                              <tr>
                                <th class="pay-detail_table-cell_reward">①発注⾦額（税抜）</th>
                                <th class="pay-detail_table-cell_tax_percent">②消費税率</th>
                                <th class="pay-detail_table-cell_tax">③消費税額</th>
                                <th class="pay-detail_table-cell_withholding" if={invoice.company_type === 2}>④源泉徴収税額</th>
                                <th class="pay-detail_table-cell_price_total" if={invoice.company_type === 2}>差引請求額（①+③-④）</th>
                                <th class="pay-detail_table-cell_price_total" if={invoice.company_type === 1}>請求額（①+③）</th>
                              </tr>
                              <tr>
                                <td class="pay-detail_table-cell_reward"><number-format number={invoice.sub_amount_project} />円</td>
                                <td class="pay-detail_table-cell_tax_percent">
                                  <tax-rate tax_rate={invoice.tax_rate} invoice_provider_state_worker={invoice.invoice_provider_state_worker} />
                                </td>
                                <td class="pay-detail_table-cell_tax">
                                  <tax-price tax_price={invoice.tax_project} invoice_provider_state_worker={invoice.invoice_provider_state_worker} unit_char="¥" />
                                </td>
                                <td class="pay-detail_table-cell_withholding" if={invoice.company_type === 2}>▲ <number-format number={invoice.tax_withholding} />円</td>
                                <td class="pay-detail_table-cell_price_total"><number-format number={invoice.amount_project} />円</td>
                              </tr>
                            </tbody>
                          </table>
                        -->
                <!--/.contents_table-->

                <!--
                  <p class="note margin-spacing-1_bottom">※「受託者」の名前は、EDILENTの公開名ではなく編集者・ライター様の本名になります。</p>
                -->
                <p class="note">※編集者・ライター様への報酬の支払いは納品単位で行います。<br>　複数の制作物が含まれるプロジェクトの場合はそれぞれの制作物に設定された上記の請求額が都度、納品されるごとに編集者・ライター様に支払われます。
                </p>


            </div><!--/.contents_block-->
            <ul class="margin-spacing-1_top" style="text-align:right;font-size:1.2rem">
                <li>
                    CROCO株式会社
                </li>
                <li if={invoice.invoice_provider_state_worker === 20}>
                    <span>適格請求書発行事業者登録番号:</span>
                    <span>T9011001104342</span>
                </li>
            </ul>


        </section><!--/.contents_area-->

    </div><!--/.contents-->


    <style>
        .container_pay {
            width: 100%;
            height: auto;
            padding: 0 32px;
            border: #49868E 2px solid;
            border-radius: 6px;
            background-color: #FFFFFF;
            display: flex;
            justify-content: space-between;
            align-items: center;
            box-sizing: border-box;
            flex-wrap: wrap;
        }

        .pay_info {
            width: 100%;
            padding: 16px 0 16px;
            background-image: linear-gradient(to right, #B5B5B5, #B5B5B5 5px, transparent 5px, transparent 10px);
            background-size: 10px 1px;
            background-repeat: repeat-x;
            background-position: bottom;
            display: flex;
            justify-content: space-between;
        }

        .wrap_pay {
            width: 100%;
            display: flex;
            align-items: center;
            padding: 16px 0;
            justify-content: space-between;
        }
    </style>

    <script>
        import di from "dependeny-injection";
        import taxUnitLabel from "@tags/parts/money/invoice-provider/tax-unit-label.riot";
        import taxRate from "@tags/parts/money/invoice-provider/tax-rate.riot";
        import taxPrice from "@tags/parts/money/invoice-provider/tax-price.riot";
        import dayjs from "dayjs";

        export default {
            components: {
                "tax-rate": taxRate,
                "tax-price": taxPrice,
                "tax-unit-label": taxUnitLabel,
            },
            invoice: {},
            project_sum: {},
            fee_sum: {},
            loaded: false,
            calcProjectSum(data) {
                let sub_amount = 0;
                let tax_rate = 0;
                let tax = 0;
                let tax_withholding = 0;
                let amount = 0;
                data.forEach(item => {
                    sub_amount += item.sub_amount;
                    tax += item.tax;
                    tax_rate = item.tax_rate;
                    tax_withholding += item.tax_withholding;
                    amount += item.amount;
                });
                this.project_sum = {
                    sub_amount: sub_amount,
                    tax_rate: tax_rate,
                    tax: tax,
                    tax_withholding: tax_withholding,
                    amount: amount
                };
            },
            date_format(date) {
                return dayjs(date).format("YYYY年MM月DD日");
            },
            calcFeeSum(data) {
                let sub_amount = 0;
                let tax_rate = 0;
                let tax = 0;
                let amount = 0;
                data.forEach(item => {
                    sub_amount += item.sub_amount;
                    tax += item.tax;
                    tax_rate = item.tax_rate;
                    amount += item.amount;
                });
                this.fee_sum = {
                    sub_amount: sub_amount,
                    tax_rate: tax_rate,
                    tax: tax,
                    amount: amount
                };
            },
            pdf(e, project_id) {
                //window.open(`/project/invoice/api/v1/fetch-pdf?invoice_id=${invoice_id}`, `invoice-pdf-${invoice_id}`);
                this.api.request("invoice", "fetch-pdf-for-project", {project_id: project_id})
                    .then(data => {
                        var binaryString = window.atob(data);
                        var binaryLen = binaryString.length;
                        var bytes = new Uint8Array(binaryLen);
                        for (var i = 0; i < binaryLen; i++) {
                            var ascii = binaryString.charCodeAt(i);
                            bytes[i] = ascii;
                        }
                        var newBlob = new Blob([bytes], {type: "application/pdf"});
                        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                            window.navigator.msSaveOrOpenBlob(newBlob);
                            return;
                        }
                        var data = window.URL.createObjectURL(newBlob);

                        var link = document.createElement('a');
                        document.body.appendChild(link); //required in FF, optional for Chrome
                        link.href = data;
                        link.download = `project-invoice-${project_id}.pdf`;
                        link.click();
                        window.URL.revokeObjectURL(data);
                        link.remove();
                    })
            },
            onBeforeMount(props, state) {
                if (!props.routeParams[0]) {
                    return;
                }
                this.project_id = props.routeParams[0];
                this.api = di.createApi('project');
                this.api.request('invoice', 'fetch-detail-for-project', {project_id: this.project_id})
                    .then(data => {
                        this.invoice = data;
                        //console.log(data)
                        /*
                        this.calcProjectSum(data.invoice_detail_items_project);
                        this.calcFeeSum(data.invoice_detail_items_service_fee);
                         */
                        this.loaded = true;
                        this.update();
                    });
            }
        };
    </script>
</invoice-detail-tag>
